export enum ProfessionTypeModel {
  Aucun = 0,
  Promotion = 1,
  Commerce = 2,
  HANDP = 3,
  OtherPromotion = 4,
  OtherCommerceCorporate = 5,
}
